module.exports = __webpack_public_path__ + "img/cloudBg.0b2ceacc.png";